import React, { useState, useEffect, useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import routes from '../../../utils/constants/routes';
import CarouselModal from './CarouselModal';
import GlobalTheme from '../../../styled/GlobalTheme';
import BodySlider from './BodySlider';
import HeaderSlider from './HeaderSlider';
import { welcomeModal, loginApp, piper } from '../../../assets/illustrations/illustrationRepository';
import Pipers from '../../../components/Pipers/Pipers';
import useCallGA from '../../../hooks/useCallGA';
import { WebViewContext } from '../../../contexts/WebViewContext';
import PromoCodeContext from '../../../contexts/PromoCodeContext';
import sanitizePlans from '../../CreateAccount/sanitizePlans';
import { Button, ButtonLink } from '../../../components/buttons';
import mediaQueries from '../../../utils/mediaQueries';

const HeaderLogin = styled.div`
  background: ${(props) => props.theme.colors.secondary};
  max-width: 100%;
  width: auto;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-image: url(${loginApp.headerLandscape});

  ${GlobalTheme.breakpoints.down('md')} {
    background-image: url(${loginApp.headerTablet});
  }

  ${GlobalTheme.breakpoints.down('xs')} {
    background-image: url(${loginApp.headerMobile});
  }

  ${GlobalTheme.breakpoints.up('md')} {
    height: 550px;
    background-image: url(${loginApp.headerLandscape});
    position: absolute;
    top: 0;
    left: 0;
    right: 0
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 130px;
  @media (max-width: 1366px) and (orientation: landscape) {
    margin-top: 75px;
  }
`;
const PiperContainer = styled.div`
  display: flex;
  max-width: 340px;
`;

const FooterLogin = styled.div`
  max-width: 100%;
  width: auto;
  padding: 255px 10px 0 10px;

  height: 295px;
  background-image: url(${loginApp.footerLandscape});

  background-repeat: no-repeat;
  background-size: 115% auto;
  background-color: #fd0;
  background-position: bottom;

  ${GlobalTheme.breakpoints.down('md')} {
    height: 255px;
    background-image: url(${loginApp.footerTablet});
    padding: 175px 10px 0 10px;
  }

  ${GlobalTheme.breakpoints.down('xs')} {
    height: ${(props) => (props.isAppIOS ? '165px;' : '185px;')};
    background-image: url(${loginApp.footerMobile});
    padding: 95px 15px 0 15px;
  }

  ${GlobalTheme.breakpoints.up('md')} {
    height: 435px;
    background-image: url(${loginApp.footerLandscape});
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  @media (min-width: 1024px) and (orientation: landscape) {
    padding-top: 120px;
  }
  @media (min-width: 1080px) and (orientation: landscape) {
    padding-top: 160px;
  }
  @media (min-width: 1194px) and (orientation: landscape) {
    padding-top: 162px;
  }
  @media (min-width: 1366px) and (orientation: landscape) {
    padding-top: 210px;
  }
`;

const FooterLegacy = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  ${GlobalTheme.breakpoints.up('md')} {
    padding-top: 0;
  }

  ${GlobalTheme.breakpoints.up('lg')} {
    padding-top: 125px;
  }
`;

const Text = styled.div`
  font-size: 10px;
  text-align: center;
  width: 100%;
`;

const CopyrightElement = styled.div`
  font-size: 9px;
  color: white;
  ${GlobalTheme.breakpoints.up('sm')} {
    font-size: 12px;
  }
  ${GlobalTheme.breakpoints.up('md')} {
    font-size: 14px;
    margin-bottom: 20px;
  }
`;

const Slider = styled.div`
  position: relative;
  width: 100%;
  background: ${({ theme, color }) => (theme.colors[color])};
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 150px 1fr 58px;
  ${GlobalTheme.breakpoints.down('sm')} {
    grid-template-rows: auto 1fr 58px;
  }
  @media (max-height: 425px) {
    grid-template-rows: 1fr 2fr 58px;
  }
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  margin-top: 46px;
`;
const ButtonContainer = styled.div`
  width: 100%;
  height: max-content;
  display: flex;
  justify-content: center;
  &:nth-child(1) {
    margin-bottom: 16px;
  }
  @media ${mediaQueries.mdUp} {
    &:nth-child(1) {
      margin-bottom: 24px;
    }
  }
`;
const CustomButton = styled(Button)`
  && {
    color: ${({ theme }) => theme.colors.grayMediaLibrary};
    background: ${({ theme }) => theme.colors.white};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    width: 235px;
    &:hover {
      background: ${({ theme }) => theme.colors.white};
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    }
    @media ${mediaQueries.mdUp} {
      font-size: 20px;
      width: 362px;
      padding-top: 18px;
      padding-bottom: 18px;
    }
  }
`;
const CustomButtonLink = styled(ButtonLink)`
  && {
    color: ${({ theme }) => theme.colors.grayMediaLibrary};
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
  }
`;
const TryPiperText = styled.p`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.grayMediaLibrary};
  margin-top: 0;
  margin-bottom: 6px;
  @media ${mediaQueries.mdUp} {
    font-size: 24px;
    margin-bottom: 12px;
  }
`;
const TrialText = styled.p`
  font-size: 22px;
  color: ${({ theme }) => theme.colors.lightPurple};
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 6px;
  @media ${mediaQueries.mdUp} {
    font-size: 40px;
    margin-bottom: 16px;
  }
`;
const TrialHelpText = styled.p`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.grayMediaLibrary};
  margin: 0;
  @media ${mediaQueries.mdUp} {
    font-size: 18px;
  }
`;
const WelcomeModal = () => {
  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(false);
  const intl = useIntl();
  const { isAppIOS } = useContext(WebViewContext);
  const history = useHistory();
  const { PromoCode } = useContext(PromoCodeContext);
  const [trialDaysM, setTrialDaysM] = useState(0);
  const [trialDays, setTrialDays] = useState(0);

  const getImageNameByLanguage = (sliderName) => {
    if (intl.locale === 'es') {
      return welcomeModal[`${sliderName}Es`];
    }
    return welcomeModal[`${sliderName}En`];
  };

  const callGA = useCallGA();

  const sliders = [
    {
      color: 'secondary',
      header: {
        text: intl.formatMessage({
          id: 'welcomeModal.slide1.text',
          defaultMessage: 'Check our Creative Center and choose from the recommendations from Piper or from our hundreds of ready-to-use templates.',
        }),
      },
      body: {
        images: {
          md: getImageNameByLanguage('sliderOne'),
          sm: getImageNameByLanguage('sliderOneSm'),
        },
        hasPiper: false,
      },
    },
    {
      color: 'secondary',
      header: {
        text: intl.formatMessage({
          id: 'welcomeModal.slide2.text',
          defaultMessage: 'Get “Good time to post” recommendations to publish your content, schedule it and organize your content and Ads.',
        }),
      },
      body: {
        images: {
          md: getImageNameByLanguage('sliderTwo'),
          sm: getImageNameByLanguage('sliderTwoSm'),
        },
        hasPiper: false,
      },
    },
    {
      color: 'secondary',
      header: {
        text: intl.formatMessage({
          id: 'welcomeModal.slide3.text',
          defaultMessage: 'Easily create Social Ads, check their performance and manage your advertising budget.',
        }),
      },
      body: {
        images: {
          md: getImageNameByLanguage('sliderThree'),
          sm: getImageNameByLanguage('sliderThreeSm'),
        },
        hasPiper: false,
      },
    },
    {
      color: 'secondary',
      header: {
        text: (
          <FormattedMessage
            id="welcomeModal.slide4.text"
            defaultMessage="<TryPiperText>Try Social Piper now!</TryPiperText> <TrialText>{trialDays} day-free trial!</TrialText> <TrialHelpText>No risk. Cancel any time. A card is required.</TrialHelpText>"
            values={{
              TryPiperText: (...chunks) => <TryPiperText>{chunks}</TryPiperText>,
              TrialText: (...chunks) => <TrialText>{chunks}</TrialText>,
              TrialHelpText: (...chunks) => <TrialHelpText>{chunks}</TrialHelpText>,
              trialDays,
            }}
          />
        ),
      },
      body: {
        images: {
          md: piper.PiperRun,
          sm: piper.PiperRun,
        },
        hasPiper: true,
      },
    },
  ];

  const checkForFirstTimeLoaded = () => {
    const result = window.localStorage.getItem('isFirstTimeOpen');
    if (result === null) setIsFirstTimeLoad(true);
  };

  useEffect(() => {
    checkForFirstTimeLoaded();
  }, []);

  const handleClick = (to) => {
    window.localStorage.setItem('isFirstTimeOpen', 'false');
    setIsFirstTimeLoad(false);
    history.push(to);
  };

  useEffect(() => {
    const [monthlyPlan] = sanitizePlans(PromoCode);
    setTrialDaysM(monthlyPlan.trialDuration);
    setTrialDays(monthlyPlan.trialDuration);
  }, [PromoCode, trialDaysM]);

  return (
    <CarouselModal
      open={isFirstTimeLoad}
      header={(
        <HeaderLogin>
          <HeaderContainer>
            <PiperContainer>
              <Pipers.PiperHeadLoginApp />
            </PiperContainer>
          </HeaderContainer>
        </HeaderLogin>
      )}
      sliders={
        sliders.map((slider) => (
          <Slider color={slider.color}>
            <HeaderSlider
              text={slider.header.text}
            />
            <BodySlider
              images={slider.body.images}
              hasPiper={slider.body.hasPiper}
            />
          </Slider>
        ))
      }
      buttons={(
        <ButtonsWrapper>
          <ButtonContainer>
            <CustomButton onClick={() => handleClick(routes.CREATE_ACCOUNT_APP)}>
              <FormattedMessage
                id="welcomeModal.createAccount.button.text"
                defaultMessage="Create account"
              />
            </CustomButton>
          </ButtonContainer>
          <ButtonContainer>
            <CustomButtonLink onClick={() => handleClick(routes.LOGIN_APP)}>
              <FormattedMessage
                id="k.login"
                defaultMessage="LOG IN"
              />
            </CustomButtonLink>
          </ButtonContainer>
        </ButtonsWrapper>
      )}
      footer={(
        <FooterLogin isAppIOS={isAppIOS}>
          <FooterLegacy>
            <Text className="">
              <CopyrightElement>
                <FormattedMessage
                  id="k.copyrightApp"
                  defaultMessage="© Copyright {year} All rights reserved"
                  values={{
                    year: new Date().getFullYear(),
                  }}
                />
              </CopyrightElement>
            </Text>
          </FooterLegacy>
        </FooterLogin>
      )}
    />
  );
};

export default WelcomeModal;
